import React, { useState, useEffect, MouseEventHandler } from "react";
import { Row, Col, Divider } from "antd";
import { SearchForm } from "../../components/SearchForm/SearchForm";
import { FieldData } from "../../components/ApplicationCreate/ApplicationCreate";
import { IConstructorJsxFilteredListClient } from "../../interfaces/Constructor/IConstructorJsxFilteredListClient";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import {
  UI_ModuleCard,
  UI_ModuleTextDownCard,
  UI_ModuleTitleCard,
  UI_ITOModuleTitle,
  UI_ITOTooltip,
} from "../../UI_ITO/indexUI";
import { ClientInfo } from "../../components/ListClient/ClientInfo/ClientInfo/ClientInfo";
import {
  SELECT_CLIENT_FOR_AGENT,
  SELECT_LIST_CLIENT_FOR_AGENT,
} from "../../store/selectors/listClientForAgentSelector";
import {
  CHANGE_SELECTED_CLIENT_FOR_AGENT,
  IOrganization,
} from "../../store/slice/listClientForAgentSlice/listClientForAgentSlice";

import classes from "./style/PageListClientForAgent.module.css";
import { SearchOutlined } from "@ant-design/icons";

// страница списка клиентов для агента
export function PageListClientForAgent() {
  const dispatch = useAppDispatch();
  const listClient = useAppSelector(SELECT_LIST_CLIENT_FOR_AGENT);
  const selectedClient = useAppSelector(SELECT_CLIENT_FOR_AGENT);
  const [filteredListClient, setFilteredListClient] =
    useState<IOrganization[]>(listClient);
  const [clientConstructor, setClientConstructor] =
    useState<keyof IConstructorJsxFilteredListClient>("EMPTY");
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  // записывает список клиентов
  useEffect(() => {
    if (listClient?.length !== 0) {
      setFilteredListClient(listClient);
      setClientConstructor("LIST");
    }
  }, [listClient]);

  function handleMouseOver(event: React.MouseEvent<HTMLDivElement>) {
    const targetElement = event.target as HTMLDivElement;
    if (targetElement.offsetWidth < targetElement.scrollWidth) {
      setTooltipVisible(true);
    }
  }

  function handleMouseOut() {
    setTooltipVisible(false);
  }

  function changeSelectedClient(client: IOrganization) {
    dispatch(CHANGE_SELECTED_CLIENT_FOR_AGENT(client));
  }

  function getCardClasses(id: number) {
    return `${classes.card} ${selectedClient.id === id ? classes.card_isActive : ""}`;
  }

  function renderClientName(title: string) {
    return (
      <UI_ITOTooltip title={selectedClient?.name} isOpen={isTooltipVisible}>
        <div
          className={classes.titleClient}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
        >
          {title}
        </div>
      </UI_ITOTooltip>
    );
  }

  const ConstructorJsxFilteredListClient: IConstructorJsxFilteredListClient = {
    LIST: (
      <div className={classes.cardWrapper}>
        {filteredListClient?.map((client) => (
          <UI_ModuleTitleCard
            className={getCardClasses(client.id)}
            onClick={() => changeSelectedClient(client)}
            key={client.id}
            title={`${client.name}`}
            textDown={
              <UI_ModuleTextDownCard textDown={[`ИНН ${client.inn}`]} />
            }
          />
        ))}
      </div>
    ),
    EMPTY_SEARCH: <div>Ничего не найдено</div>,
    EMPTY: <div>Пока нет клиентов</div>,
  };

  const handleSearch = (searchFormData: FieldData[]) => {
    setFilteredListClient(() => {
      if (searchFormData[0].value) {
        const searchText = searchFormData[0].value as string;
        return listClient?.filter(
          (client: IOrganization) =>
            client?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
            String(client?.inn).includes(searchText),
        );
      } else {
        return listClient;
      }
    });
    if (filteredListClient?.length === 0) {
      setClientConstructor("EMPTY_SEARCH");
    } else {
      setClientConstructor("LIST");
    }
  };

  return (
    <>
      <Row style={{ margin: "0" }}>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={14}
          className={classes.listClientPageLeftContainer}
        >
          <Row className={classes.listClientPageHeader}>
            <Col>
              <UI_ITOModuleTitle title={"Список Клиентов"} />
            </Col>
          </Row>
          <SearchForm 
            handleSearch={handleSearch} 
            placeholder="Поиск клиента" 
          />
          <div className={classes.clientListContainer}>
            <Divider orientation="left" orientationMargin="0">
              Список клиентов
            </Divider>
            {ConstructorJsxFilteredListClient[clientConstructor]}
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={12} xl={10}>
          {selectedClient && (
            <UI_ModuleCard
              title={renderClientName(selectedClient?.name)}
              style={{
                height: "100%",
                margin: "0",
              }}
            >
              <ClientInfo />
            </UI_ModuleCard>
          )}
        </Col>
      </Row>
    </>
  );
}
